import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col md-7" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "mt-3" }, "Zoznam užívateľov", -1)
const _hoisted_5 = { class: "table table-compact table-striped hover" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Užívateľ"),
    /*#__PURE__*/_createElementVNode("th", null, "Spoločnosť"),
    /*#__PURE__*/_createElementVNode("th", null, "Email"),
    /*#__PURE__*/_createElementVNode("th", null, "Tel"),
    /*#__PURE__*/_createElementVNode("th", null, "Rola"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_router_link, {
          to: "/admin/users/0",
          class: "btn btn-primary float-end"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Pridať užívateľa")
          ]),
          _: 1
        }),
        _createElementVNode("table", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.users, (u) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: u.id
              }, [
                _createElementVNode("td", null, [
                  _createVNode(_component_router_link, {
                    to: `/admin/users/${u.id}`
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(u.lastName) + " " + _toDisplayString(u.firstName), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _createElementVNode("td", null, _toDisplayString(u.company), 1),
                _createElementVNode("td", null, _toDisplayString(u.email), 1),
                _createElementVNode("td", null, _toDisplayString(u.phone), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("span", null, _toDisplayString(u.role.name), 1)
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_router_link, {
                    to: `/admin/users/${u.id}`,
                    class: "btn btn-primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Upraviť")
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}